import {useCallback, useState} from 'react';

import {shouldShowFlowchartProcedureRunDesignOptInBanner} from 'studies/typed/shared/procedure-runs/design-tabs/ProcedureRunDesignUtils';

export interface UseFlowchartProcedureRunDesignPreviewStateResult {
  /** Whether to show the legacy-UI banner offering to opt in to the flowchart design. */
  shouldShowNewUIOptInBanner: boolean;
  /** Dismisses the opt-in banner for the remainder of this session. */
  dismissNewUIOptInBanner: () => void;
  /** Whether the flowchart-UI banner offering to opt out has been dismissed this session. */
  isOptOutBannerDismissed: boolean;
  /** Dismisses the opt-out banner for the remainder of this session. */
  dismissOptOutBanner: () => void;
}

/**
 * Owns the opt-in/opt-out preview banner dismissal state shared by the flowchart and legacy
 * procedure run design UIs.
 */
export function useFlowchartProcedureRunDesignPreviewState(): UseFlowchartProcedureRunDesignPreviewStateResult {
  const [isNewUIOptInBannerDismissed, setIsNewUIOptInBannerDismissed] = useState(false);
  const shouldShowNewUIOptInBanner =
    shouldShowFlowchartProcedureRunDesignOptInBanner() && !isNewUIOptInBannerDismissed;
  const dismissNewUIOptInBanner = useCallback(() => {
    setIsNewUIOptInBannerDismissed(true);
  }, []);

  const [isOptOutBannerDismissed, setIsOptOutBannerDismissed] = useState(false);
  const dismissOptOutBanner = useCallback(() => {
    setIsOptOutBannerDismissed(true);
  }, []);

  return {
    shouldShowNewUIOptInBanner,
    dismissNewUIOptInBanner,
    isOptOutBannerDismissed,
    dismissOptOutBanner,
  };
}
